const businessDiagnosisDictES = {
  businessDiagnosis: "Evaluación de la empresa",
  businessDiagnosisSubtitle:
    "Estimado emprendedor, a continuación encontrarás una serie de preguntas para hacer que tu empresa sea aún más EFICIENTE, EFICAZ, ECONÓMICA y SOSTENIBLE. El ingenio, la dedicación, la profesionalidad y la colaboración te permitirán recorrer un camino virtuoso en conjunto.",

  businessDiagnosisMenuSelection: "Menú de selección",

  businessDiagnosisInProgress: "Diagnóstico de la empresa en pausa",
  businessDiagnosisProgressDescription:
    "Descubre cómo hacer que tu empresa sea más asequible y sostenible.",
  businessDiagnosisProgressLabel: "Progreso:",
  businessDiagnosisProgressStep: "Fase {current} de {total}",
  businessDiagnosisContinue: "Continuar el Diagnóstico",

  businessDiagnosisStep1Title: "Datos de la Empresa",
  businessDiagnosisStep2Title: "Estructura de la Empresa",
  businessDiagnosisStep3Title: "Tamaño de la Empresa",
  businessDiagnosisStep4Title: "Capital Humano por Género",
  businessDiagnosisStep5Title: "Capital Humano por Puestos",
  businessDiagnosisStep6Title: "Capital Humano",
  businessDiagnosisStep7Title: "Representaciones",
  businessDiagnosisStep8Title: "Otras Informaciones",

  businessDiagnosisStep1Description:
    "Introduce los datos generales de tu empresa para ayudarnos a comprender mejor tu identidad y el contexto en el que operas.",
  businessDiagnosisStep2Description:
    "Describe la composición y la organización interna de tu empresa para comprender su solidez y capacidad operativa.",
  businessDiagnosisStep3Description:
    "Especifica el tamaño de tu empresa para orientarnos mejor a la hora de evaluar tus necesidades y tu potencial de crecimiento.",
  businessDiagnosisStep4Description:
    "Cuéntanos cuántos empleados tiene tu empresa y sus competencias, para potenciar tu capital humano.",
  businessDiagnosisStep5Description:
    "Especifica los principales puestos y responsabilidades de los empleados, destacando los roles clave para el crecimiento de la empresa.",
  businessDiagnosisStep6Description:
    "Introduce los datos relacionados con el personal empleado en tu empresa, dividido por roles, competencias y áreas operativas.",
  businessDiagnosisStep7Description:
    "Proporciona información sobre posibles representantes legales o comerciales de tu empresa, tanto a nivel nacional como internacional.",
  businessDiagnosisStep8Description:
    "Explica cómo tu empresa utiliza herramientas tecnológicas y estrategias innovadoras para mantenerse competitiva.",

  back: "Atrás",
  saveAndContinue: "Guardar y continuar",
  sendDiagnosis: "Enviar Diagnóstico",

  businessDiagnosisConsent: "Doy mi consentimiento",
  businessDiagnosisConsentText:
    "I consent to the use of the information provided for a free assessment for the EXTRACONOMY platform and authorize the processing of data in accordance with current legislation and GDPR.",

  // Shared helpers
  select: "Seleccionar",
  businessDiagnosisNoData: "—",

  // Step 1
  businessDiagnosisStep1LabelCompanyName: "Razón Social",
  businessDiagnosisStep1LabelRegisteredOffice: "Sede Social",
  businessDiagnosisStep1LabelAddress: "Dirección",
  businessDiagnosisStep1LabelVatNumber: "Número de IVA",
  businessDiagnosisStep1LabelAtecoCode: "Código ATECO",
  businessDiagnosisStep1LabelSector: "Sector",
  businessDiagnosisStep1LabelLegalRepresentative: "Representante Legal",
  businessDiagnosisStep1LabelPhone: "Teléfono",
  businessDiagnosisStep1LabelAdministrativeRepresentative: "Representante Administrativo",
  businessDiagnosisStep1LabelWebsite: "Sitio web",
  businessDiagnosisStep1PlaceholderWebsite: "https://",
  businessDiagnosisStep1LabelEmail: "Email",
  businessDiagnosisStep1LabelCompanyDescription: "Breve descripción de la empresa",
  businessDiagnosisStep1PlaceholderCompanyDescription:
    "Breve descripción de la misión y actividades.",
  businessDiagnosisStep1LabelLawFirm: "Bufete de abogados",
  businessDiagnosisStep1LabelAccountingFirm: "Despacho contable",
  businessDiagnosisStep1LabelLaborConsultant: "Asesor laboral",

  // Step 2
  businessDiagnosisStep2OrganizationalChartLabel: "Organigrama",
  businessDiagnosisStep2OrganizationalChartHelp: "¿La empresa tiene un organigrama?",
  businessDiagnosisStep2CompanyRegulationsLabel: "Reglamento de la empresa",
  businessDiagnosisStep2CompanyRegulationsHelp: "¿Existe una normativa interna?",
  businessDiagnosisStep2OrganizationalModel231Label: "Modelo organizativo 231/01",
  businessDiagnosisStep2OrganizationalModel231Help: "¿Adopta el modelo 231/01?",
  businessDiagnosisStep2ModelOt23Label: "Modelo OT23 - ISI INAIL",
  businessDiagnosisStep2ModelOt23Help: "¿La empresa aplica modelos OT23/INAIL?",
  businessDiagnosisStep2CodeOfEthicsLabel: "Código de ética",
  businessDiagnosisStep2CodeOfEthicsHelp: "¿La empresa tiene código ético?",
  businessDiagnosisStep2LegalityRatingLabel: "Calificación de legalidad",
  businessDiagnosisStep2LegalityRatingHelp: "¿Ha obtenido una calificación de legalidad?",
  businessDiagnosisStep2SustainabilityReportLabel: "Balance de sostenibilidad",
  businessDiagnosisStep2SustainabilityReportHelp: "¿Publica informes de sostenibilidad?",
  businessDiagnosisStep2SecondaryOfficesLabel: "Sedes secundarias",
  businessDiagnosisStep2SecondaryOfficesHelp: "¿Hay sedes secundarias?",
  businessDiagnosisStep2SecondaryOfficesWhere: "Si es así, indicar dónde",
  businessDiagnosisStep2IndustryAssociationLabel: "Afiliación a asociaciones del sector",
  businessDiagnosisStep2IndustryAssociationHelp: "Adhesión a asociaciones del sector.",
  businessDiagnosisStep2IndustryAssociationWhich: "Si es así, indicar cuáles",
  businessDiagnosisStep2InterprofessionalFundsLabel: "Fondos interprofesionales",
  businessDiagnosisStep2InterprofessionalFundsHelp: "Participación en fondos interprofesionales.",
  businessDiagnosisStep2InterprofessionalFundsWhich: "Si es así, indicar cuáles",
  businessDiagnosisStep2BilateralEntityLabel: "Entidad bilateral",
  businessDiagnosisStep2BilateralEntityHelp: "¿Está inscrita en una entidad bilateral?",
  businessDiagnosisStep2BilateralEntityWhich: "Si es así, indicar cuál",

  // Step 3
  businessDiagnosisStep3LabelEmployees: "Nº de empleados",
  businessDiagnosisStep3EmployeesHelp:
    "Indica el tamaño de la empresa según el número de empleados.",
  businessDiagnosisStep3LabelRevenue: "Facturación",
  businessDiagnosisStep3RevenueHelp: "Indica el tramo de facturación anual.",

  businessDiagnosisSizeEmployeesMicro: "Microempresa (<10)",
  businessDiagnosisSizeEmployeesSmall: "Pequeña empresa (10-49)",
  businessDiagnosisSizeEmployeesMedium: "Empresa mediana (50-249)",
  businessDiagnosisSizeEmployeesLarge: "Gran empresa (250+)",

  businessDiagnosisSizeRevenueLte2: "Hasta 2 millones",
  businessDiagnosisSizeRevenue2To10: "2 a 10 millones",
  businessDiagnosisSizeRevenue10To50: "10 a 50 millones",
  businessDiagnosisSizeRevenueGt50: "Más de 50 millones",

  // Step 4
  businessDiagnosisStep4LabelTotalEmployees: "Nº TOTAL DE EMPLEADOS",
  businessDiagnosisStep4LabelWomen: "Mujeres",
  businessDiagnosisStep4GenderDistributionHelp: "Distribución de género.",
  businessDiagnosisStep4LabelMen: "Hombres",
  businessDiagnosisStep4LabelOtherGender: "Otro género",

  // Step 5
  businessDiagnosisStep5InternalHrLabel: "RR.HH. interno",
  businessDiagnosisStep5InternalHrHelp:
    "Indique si existe una oficina o responsable de RR.HH. interno.",
  businessDiagnosisStep5SecondLevelContractLabel: "Contrato de segundo nivel",
  businessDiagnosisStep5SecondLevelContractHelp:
    "Indicar si la empresa aplica contratos de segundo nivel (integraciones al CCNL).",
  businessDiagnosisStep5OngoingLaborDisputesLabel: "Conflictos laborales en curso",
  businessDiagnosisStep5OngoingLaborDisputesHelp:
    "Indicar si actualmente hay conflictos laborales en curso.",
  businessDiagnosisStep5ConcludedLaborDisputesLabel: "Conflictos laborales finalizados",
  businessDiagnosisStep5ConcludedLaborDisputesHelp:
    "Indicar si la empresa ha finalizado conflictos laborales en el pasado.",
  businessDiagnosisStep5UnionRepresentativesLabel: "Representantes sindicales",
  businessDiagnosisStep5UnionRepresentativesHelp:
    "Indicar si hay representantes sindicales activos en la empresa.",
  businessDiagnosisStep5UnionRepresentativesWhichLabel: "Si es así, indicar cuáles",
  businessDiagnosisStep5UnionRepresentativesWhichHelp:
    'Si has respondido "SÍ" arriba, especificar qué contratos, conflictos o representantes.',
  businessDiagnosisStep5AppliedCcnlLabel: "CCNL aplicado",
  businessDiagnosisStep5AppliedCcnlPlaceholder:
    "Indique qué CCNL (Convenio Colectivo Nacional de Trabajo) se aplica en la empresa.",

  // Step 6
  businessDiagnosisStep6StaffingAgenciesLabel: "Uso de agencias de empleo",
  businessDiagnosisStep6StaffingAgenciesHelp:
    "Indica si la empresa utiliza agencias externas para la selección y la gestión del personal.",
  businessDiagnosisStep6DirectSeveranceLabel: "Gestión directa del TFR",
  businessDiagnosisStep6DirectSeveranceHelp:
    "Indica si la empresa gestiona internamente la indemnización por tiempo de servicio (TFR).",
  businessDiagnosisStep6UseTfmLabel: "Uso de pólizas TFM",
  businessDiagnosisStep6UseTfmHelp:
    "Especifique si la empresa utiliza pólizas TFM (Trattamento di Fine Mandato) para los administradores.",
  businessDiagnosisStep6UseKmanLabel: "Uso de pólizas KMAN",
  businessDiagnosisStep6UseKmanHelp:
    "Indica si existen pólizas de seguro KMAN activas para figuras clave de la empresa.",
  businessDiagnosisStep6CorporateWelfareLabel: "Bienestar corporativo",
  businessDiagnosisStep6CorporateWelfareHelp:
    "Indique si la empresa ofrece un plan de bienestar corporativo (beneficios y servicios para los empleados).",
  businessDiagnosisStep6HealthWelfareLabel: "Bienestar en salud",
  businessDiagnosisStep6HealthWelfareHelp:
    "Indica si la empresa ofrece pólizas o servicios de bienestar en salud a los empleados.",

  // Step 7
  businessDiagnosisStep7RsaLabel: "RSA - Representante sindical de la empresa",
  businessDiagnosisStep7RsaHelp:
    "Indique si la empresa tiene un representante sindical solo para los afiliados al sindicato.",
  businessDiagnosisStep7RsuLabel: "RSU - Representante sindical unitario",
  businessDiagnosisStep7RsuHelp:
    "Indicar si existe un representante que proteja a todos los trabajadores, afiliados y no afiliados.",
  businessDiagnosisStep7RpsLabel: "RPS - Representante de Seguridad",
  businessDiagnosisStep7RpsHelp:
    "Especifique si los trabajadores han nombrado un representante de seguridad.",
  businessDiagnosisStep7RsppLabel: "RSPP - Responsable de Seguridad y Prevención",
  businessDiagnosisStep7RsppHelp:
    "Indicar si el empleador ha nombrado un responsable de seguridad y prevención.",
  businessDiagnosisStep7RsppNameLabel: "Nombre del RSPP (indicar)",
  businessDiagnosisStep7RsppNamePlaceholder: "Escriba el nombre de la persona nombrada como RSPP.",
  businessDiagnosisStep7DvrLabel: "DVR - Documento de Evaluación de Riesgos",
  businessDiagnosisStep7DvrHelp: "Documento de evaluación de riesgos.",
  businessDiagnosisStep7DuvriLabel:
    "DUVRI - Documento Único de Evaluación de Riesgos de Interferencias",
  businessDiagnosisStep7DuvriHelp:
    "Indique si está presente el documento que evalúa los riesgos derivados de las actividades de terceros en la empresa.",

  // Step 8
  businessDiagnosisStep8LabelSocialMediaPresence: "Presencia en redes sociales",
  businessDiagnosisStep8LabelECommerce: "E-commerce",
  businessDiagnosisStep8LabelGenderEqualityCertification: "Certificación de Igualdad de Género",
  businessDiagnosisStep8LabelIso: "ISO",
  businessDiagnosisStep8IsoWhichLabel: "Indicar cuáles",
  businessDiagnosisStep8LabelCyberSecurity: "Seguridad cibernética",
  businessDiagnosisStep8LabelGdpr: "GDPR",
  businessDiagnosisStep8LabelSubsidizedFinance: "Uso de financiación subvencionada",
  businessDiagnosisStep8LabelFundedTraining: "Uso de formación financiada",
  businessDiagnosisStep8LabelHasLiquidityManager: "¿Tienes un gestor de liquidez de la empresa?",
  businessDiagnosisStep8LabelDiversifiedLiquidityWithGold:
    "¿Has diversificado la liquidez de la empresa comprando oro?",
  businessDiagnosisStep8LabelDate: "Fecha: ",
  businessDiagnosisStep8LabelConsultant: "Consultor: ",
};

export default businessDiagnosisDictES;
